export default __webpack_public_path__ + "static/media/selectoption.057ee80d.png";